import { useCallback, useEffect, useRef } from "react";
import { useGTMEvent } from "../../../../GoogleTagManager/googleTagManagerHooks";

function useTutorialIntroModalGTMEvents(isFirstShowIntro: boolean) {
    const isIntroVideoEventNeedSend = useRef(isFirstShowIntro);

    const { pushGtmEvent } = useGTMEvent();

    const handleSendIsPlayedIntroVideoGTMEvent = useCallback((isPlayed) => {
        if (isIntroVideoEventNeedSend.current) {
            pushGtmEvent({
                event: 'playIntroVideo',
                module: 'IntroModal',
                isPlayed
            })
            isIntroVideoEventNeedSend.current = false;
        }
    }, [pushGtmEvent])

    useEffect(() => () => {
        if (isIntroVideoEventNeedSend.current) {
            handleSendIsPlayedIntroVideoGTMEvent(false)
        }
    }, [handleSendIsPlayedIntroVideoGTMEvent]);

    return {handleSendIsPlayedIntroVideoGTMEvent}
}

export default useTutorialIntroModalGTMEvents;
